const CAMPOS_SERVICO_FISCAL_VENDA = [
  'tipoIss',
  'valorIss',
  'issRetidoNaFonte',
  'tipoPis',
  'valorPis',
  'pisRetidoNaFonte',
  'tipoCofins',
  'valorCofins',
  'cofinsRetidoNaFonte',
  'tipoIrrf',
  'valorIrrf',
  'irrfRetidoNaFonte',
  'tipoInss',
  'valorInss',
  'inssRetidoNaFonte',
  'tipoCsll',
  'valorCsll',
  'csllRetidoNaFonte',
  'tipoIbs',
  'valorIbs',
  'ibsRetidoNaFonte',
  'tipoIbsMunicipal',
  'valorIbsMunicipal',
  'tipoCbs',
  'valorCbs',
  'cbsRetidoNaFonte',
  'tipoIs',
  'valorIs',
  'isRetidoNaFonte',
  'possuiIbsCbs',
];

export const resolverCampoServicoFiscalVenda = (fiscalSalvo, fiscalServico, campo) => {
  if (!fiscalSalvo?.id) {
    return fiscalServico?.[campo];
  }

  if (Object.prototype.hasOwnProperty.call(fiscalSalvo, campo)) {
    return fiscalSalvo[campo];
  }

  return null;
};

export const mergeServicoFiscalVenda = (fiscalServico = {}, fiscalSalvo) => {
  if (!fiscalSalvo) {
    return { ...fiscalServico };
  }

  if (!fiscalSalvo.id) {
    return {
      ...fiscalServico,
      ...fiscalSalvo,
      cstSituacaoTributaria: fiscalSalvo.cstSituacaoTributaria?.id
        ? fiscalSalvo.cstSituacaoTributaria
        : fiscalServico.cstSituacaoTributaria,
      cstClassificacaoTributaria: fiscalSalvo.cstClassificacaoTributaria?.id
        ? fiscalSalvo.cstClassificacaoTributaria
        : fiscalServico.cstClassificacaoTributaria,
    };
  }

  const merged = {
    ...fiscalServico,
    id: fiscalSalvo.id,
    cstSituacaoTributaria: fiscalSalvo.cstSituacaoTributaria?.id
      ? fiscalSalvo.cstSituacaoTributaria
      : fiscalServico.cstSituacaoTributaria,
    cstClassificacaoTributaria: fiscalSalvo.cstClassificacaoTributaria?.id
      ? fiscalSalvo.cstClassificacaoTributaria
      : fiscalServico.cstClassificacaoTributaria,
  };

  CAMPOS_SERVICO_FISCAL_VENDA.forEach((campo) => {
    merged[campo] = resolverCampoServicoFiscalVenda(fiscalSalvo, fiscalServico, campo);
  });

  return merged;
};

export const buildServicoFiscalInitialValue = (fiscalServico = {}, fiscalSalvo) => {
  const base = {
    tipoIss: fiscalServico.tipoIss || 'PERCENTUAL',
    valorIss: fiscalServico.valorIss,
    issRetidoNaFonte: fiscalServico.issRetidoNaFonte,

    tipoPis: fiscalServico.tipoPis || 'PERCENTUAL',
    valorPis: fiscalServico.valorPis,
    pisRetidoNaFonte: fiscalServico.pisRetidoNaFonte,

    tipoCofins: fiscalServico.tipoCofins || 'PERCENTUAL',
    valorCofins: fiscalServico.valorCofins,
    cofinsRetidoNaFonte: fiscalServico.cofinsRetidoNaFonte,

    tipoIrrf: fiscalServico.tipoIrrf || 'PERCENTUAL',
    valorIrrf: fiscalServico.valorIrrf,
    irrfRetidoNaFonte: fiscalServico.irrfRetidoNaFonte,

    tipoInss: fiscalServico.tipoInss || 'PERCENTUAL',
    valorInss: fiscalServico.valorInss,
    inssRetidoNaFonte: fiscalServico.inssRetidoNaFonte,

    tipoCsll: fiscalServico.tipoCsll || 'PERCENTUAL',
    valorCsll: fiscalServico.valorCsll,
    csllRetidoNaFonte: fiscalServico.csllRetidoNaFonte,

    tipoIbs: fiscalServico.tipoIbs || 'PERCENTUAL',
    valorIbs: fiscalServico.valorIbs,
    ibsRetidoNaFonte: fiscalServico.ibsRetidoNaFonte,

    tipoIbsMunicipal: fiscalServico.tipoIbsMunicipal || 'PERCENTUAL',
    valorIbsMunicipal: fiscalServico.valorIbsMunicipal,

    tipoCbs: fiscalServico.tipoCbs || 'PERCENTUAL',
    valorCbs: fiscalServico.valorCbs,
    cbsRetidoNaFonte: fiscalServico.cbsRetidoNaFonte,

    tipoIs: fiscalServico.tipoIs || 'PERCENTUAL',
    valorIs: fiscalServico.valorIs,
    isRetidoNaFonte: fiscalServico.isRetidoNaFonte,

    cstSituacaoTributaria: fiscalServico.cstSituacaoTributaria,
    cstClassificacaoTributaria: fiscalServico.cstClassificacaoTributaria,
    possuiIbsCbs: fiscalServico.possuiIbsCbs,
  };

  return mergeServicoFiscalVenda(base, fiscalSalvo);
};

export const possuiIbsCbsUtilizado = (servicoFiscal) =>
  !!(
    servicoFiscal?.cstSituacaoTributaria?.id ||
    servicoFiscal?.cstClassificacaoTributaria?.id ||
    (servicoFiscal?.valorIbs || 0) > 0 ||
    (servicoFiscal?.valorIbsMunicipal || 0) > 0 ||
    (servicoFiscal?.valorCbs || 0) > 0 ||
    (servicoFiscal?.valorIs || 0) > 0
  );

export const normalizarServicoFiscalParaSalvar = (servicoFiscal, possuiIbsCbs) => {
  if (!servicoFiscal) {
    return null;
  }

  return {
    ...servicoFiscal,
    possuiIbsCbs,
    valorIbs: servicoFiscal.valorIbs ?? null,
    valorIbsMunicipal: servicoFiscal.valorIbsMunicipal ?? null,
    valorCbs: servicoFiscal.valorCbs ?? null,
    valorIs: servicoFiscal.valorIs ?? null,
    cstSituacaoTributariaId:
      servicoFiscal?.cstSituacaoTributaria?.id ?? servicoFiscal?.cstSituacaoTributariaId ?? null,
    cstClassificacaoTributariaId:
      servicoFiscal?.cstClassificacaoTributaria?.id ?? servicoFiscal?.cstClassificacaoTributariaId ?? null,
  };
};

export const prepararServicoFiscalParaSalvar = (servicoFiscal) => {
  if (!servicoFiscal) {
    return null;
  }

  return normalizarServicoFiscalParaSalvar(servicoFiscal, possuiIbsCbsUtilizado(servicoFiscal));
};
